module.exports = __webpack_public_path__ + "karadeniz inşaat 1.jpg?23e5cdfd964a1c700289341c20eef2f4";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/karadeniz inşaat 1.jpg
// module id = 342
// module chunks = 0